import React, { useRef } from 'react';
import ReactHlsPlayer from 'react-hls-player';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@carbon/react';
import { RecordedItem } from './CompliancePlayer.types';

interface PlaybackPanelProps {
  item?: RecordedItem;
  hlsUrl?: string;
  hlsPending?: boolean;
  rangeLabel?: string;
}

const PlaybackPanel: React.FC<PlaybackPanelProps> = ({ item, hlsUrl, hlsPending, rangeLabel }) => {
  const playerRef = useRef<HTMLVideoElement>(null);
  const rows = [
    { id: 'mode', label: 'Playback', value: hlsUrl ? 'Continuous HLS' : hlsPending ? 'Preparing continuous HLS' : 'Individual MP4 clip' },
    { id: 'range', label: 'Selected range', value: rangeLabel ?? '--' },
    { id: 'channel', label: 'Channel', value: item?.channel ?? '--' },
    { id: 'size', label: 'Size', value: item?.size ?? '--' },
    { id: 'date', label: 'Date & Time', value: item?.date ?? '--' },
    { id: 'file', label: 'File', value: item?.title ?? '--' },
    { id: 'job', label: 'Job ID', value: item?.jobId ?? '--' },
  ];

  return (
    <div className="compliance-player__right-main">
      <div className="compliance-player__featured">
        {hlsPending && <div className="compliance-player__hls-status">Preparing continuous playback…</div>}
        <div className="compliance-player__featured-player">
          {hlsUrl ? (
            <ReactHlsPlayer
              key={hlsUrl}
              playerRef={playerRef}
              src={hlsUrl}
              controls
              muted
              autoPlay={false}
              preload="metadata"
            />
          ) : (
            <video key={item?.id ?? 'empty'} controls muted src={item?.streamUrl ?? ''}>
              Your browser does not support the video tag.
            </video>
          )}
        </div>
      </div>

      <div className="compliance-player__metadata">
        <TableContainer className="compliance-player__metadata-table" title="">
          <Table size="sm">
            <TableBody>
              {rows.map((row) => (
                <TableRow key={row.id}>
                  <TableCell>{row.label}</TableCell>
                  <TableCell>{row.value}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

export default PlaybackPanel;
